const firebaseConfig = {
  apiKey: "AIzaSyAnl0IIxRHxIKq2YKNTi-Ah3JM9Q7P1uq8",
  authDomain: "actividades-cervantes.firebaseapp.com",
  databaseURL: "https://actividades-cervantes-default-rtdb.firebaseio.com",
  projectId: "actividades-cervantes",
  storageBucket: "actividades-cervantes.appspot.com",
  messagingSenderId: "460310034380",
  appId: "1:460310034380:web:d0bb4c497d21ec2afbcf69",
  measurementId: "G-QPDZS9STKQ"
  };
export default firebaseConfig;